import type { SubscriptionStatus } from './api';

// Etiqueta y tono de cada estado de suscripcion. Un solo lugar para la ficha y
// el buscador: el `Record` completo hace que un estado nuevo no compile hasta
// tener su etiqueta (asi quedo `pending` como una pastilla vacia).

type Tone = 'neutral' | 'success' | 'warning' | 'error' | 'info';

export const SUB_TONE: Record<SubscriptionStatus, Tone> = {
  pending: 'warning',
  active: 'success',
  trialing: 'info',
  grace_period: 'warning',
  expired: 'neutral',
  cancelled: 'neutral',
};

export const SUB_LABEL: Record<SubscriptionStatus, string> = {
  // Inicio el alta pero el primer pago no se acredito: no tiene el plan.
  pending: 'pago no completado',
  active: 'activa',
  trialing: 'en prueba',
  grace_period: 'en gracia',
  expired: 'vencida',
  cancelled: 'cancelada',
};
